import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { publicApi } from '../api/insolita';
import { useLang } from '../i18n/LanguageContext';

interface ContentContextValue {
  /** Restituisce il valore del contenuto per chiave, con fallback. */
  t: (key: string, fallback?: string) => string;
  /** Come t(), ma semantico per gli URL immagine (configurabili da backend). */
  img: (key: string, fallback?: string) => string;
  content: Record<string, string>;
  loaded: boolean;
}

const ContentContext = createContext<ContentContextValue>({
  t: (_k, fb) => fb ?? '',
  img: (_k, fb) => fb ?? '',
  content: {},
  loaded: false,
});

export const ContentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { lang } = useLang();
  const [content, setContent] = useState<Record<string, string>>({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    publicApi.content(lang)
      .then((c) => { if (active) setContent(c); })
      .catch(() => { if (active) setContent({}); })
      .finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, [lang]);

  const t = (key: string, fallback = '') => {
    const v = content[key];
    return v !== undefined && v !== null && v !== '' ? v : fallback;
  };

  return (
    <ContentContext.Provider value={{ t, img: t, content, loaded }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
